import { ChangeEvent } from "react";

export default function CheckboxField({
    label,
    id,
    name,
    value,
    handleChange,
    disabled,
}: {
    label: string,
    id: string,
    name: string,
    value: boolean,
    handleChange: (e: ChangeEvent<HTMLInputElement>) => void,
    disabled?: boolean,
}) {
    return (
        <label 
            htmlFor={id} 
            className={`w-full px-4 py-3 flex justify-start items-center gap-3 rounded-lg border hover:cursor-pointer hover:border-primary ${value ? 'border-primary bg-[#006D77]/[0.05]' : 'border-outline bg-none'}`}
        >
            <input 
                type="checkbox" 
                className="rounded accent-primary" 
                onChange={handleChange} 
                checked={value} 
                name={name} 
                id={id}
                disabled={disabled}
            />
            <p className={`font-medium ${value ? 'text-primary' : 'text-disable'}`}>
                {label}
            </p>
        </label>
    )
}